import $ from 'jquery'

export function dataTrackInit () {
  $('.list-footer-controls .pager-prev a').attr('data-track', 'prev_page')
  $('.list-footer-controls .pager-next a').attr('data-track', 'next_page')
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt543/data-track.js
 ** module id = 17
 ** module chunks = 2
 **/